import { render, staticRenderFns } from "./KompasSharing.vue?vue&type=template&id=93c9e17a&"
import script from "./KompasSharing.vue?vue&type=script&lang=js&"
export * from "./KompasSharing.vue?vue&type=script&lang=js&"
import style0 from "./KompasSharing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports